import React ,{useState}from "react";
import RegulatorService from "../../services/regulator.service";
import Modal from "react-bootstrap/Modal";
import { Button, Col, Row, Container, Stack } from "react-bootstrap";
import L from "leaflet";
import { MapContainer, TileLayer, Polygon } from "react-leaflet";
import { FaLocationDot, FaCircleCheck, FaCircleXmark } from "react-icons/fa6";
import ExportKMLButton from "../../Style_Component/Button/Exportcoord/ExportKMLButton";
import fileicon from "../../picture/file-icon.png"
import Static_modal from "../user/etc/Static_modal";
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-icon.png",
  iconUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-icon.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-shadow.png",
});

function UserOperationContentModal(props) {
  const [modalToggle, setModalToggle] = useState({
    modalSuccess: false,
    modalDenied: false,
    modalErr: false,
    modalwait: false,
  });
  const [textBody, setTextBody] = useState();
  const handleClose_Modal = (close) => {
    setModalToggle({
      ...modalToggle,
      modalSuccess: close,
      modalDenied: close,
      modalErr: close,
      modalwait: close,
    });
    setTextBody("");
  };
  function formatDate(inputString) {
    const date = new Date(inputString);
    const padZero = (num) => (num < 10 ? "0" : "") + num;

    const day = padZero(date.getDate());
    const month = padZero(date.getMonth() + 1);
    const year = date.getFullYear();
    const hours = padZero(date.getHours());
    const minutes = padZero(date.getMinutes());
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  }

  function arrayToString(inputArray) {
    console.log(inputArray);
    return inputArray.map((obj) => `${obj.Lon},${obj.Lat}`).join(" , ");
  }

  function positionsArrayToPolygon() {
    const storeArray = [];
    const polygonData = props.content.positions;
    polygonData.map((content, index) => {
      storeArray.push([content.Lat, content.Lon]);
    });
    return storeArray;
  }

  const updateOperation = (operation_id) => {
    let operationupdate = RegulatorService.AuthorizedOperation(operation_id);
    if (operationupdate != null) {
      operationupdate.then((res) => {
        window.location.reload(false);
      }).catch((error)=>{
        setTextBody(error);
        setModalToggle({ ...modalToggle, modalErr: true });
      })
    }
  };
  const Neverauthorized = (operation_id) => {
    let operationupdate = RegulatorService.DeniedOperation(operation_id);
    if (operationupdate != null) {
      operationupdate.then((res) => {
        window.location.reload(false);
      }).catch((error)=>{
        setTextBody(error);
        setModalToggle({ ...modalToggle, modalErr: true });
      })
    }
  };
  const Rescindedoperation = (operation_id) => {
    let operationupdate = RegulatorService.RescindedOperation(operation_id);
    if (operationupdate != null) {
      operationupdate.then((res) => {
        window.location.reload(false);
      }).catch((error)=>{
        setTextBody(error);
        setModalToggle({ ...modalToggle, modalErr: true });
      })
    }
  };
  const getfiletoshow = (path) => {
    const response = RegulatorService.OperationDoc(
      props.content.operation_id,
      props.content.file.path
    );
    response.then((res) => {
      console.log(res);
      const file = new Blob([res.data], { type: res.data.type });
      const fileUrl = URL.createObjectURL(file);
      //setFileUrl(fileUrl);
      window.open(fileUrl, "_blank");
      // pdfWindow.document.write(
      //   `<iframe src="${fileUrl}" width="100%" height="100%"></iframe>`
      // );
    }).catch((error)=>{
      setTextBody(error);
        setModalToggle({ ...modalToggle, modalErr: true });
    })
  };
  function VerifyStatus() {
    if (props.content.status === 1) {
      return (
        <div
          style={{
            display: "flex",
            gap: 10,
          }}
        >
          <Button
            style={{ display: "flex", gap: "5px" }}
            variant="success"
            onClick={() => {
              updateOperation(props.content.operation_id);
            }}
          >
            <FaCircleCheck style={{ marginTop: "5px", fontSize: "20px" }} />
            &nbsp;
            <h4 style={{ color: "white" }}>อนุมัติแผนการบิน</h4>
          </Button>

          <Button
            style={{ display: "flex", gap: "5px" }}
            variant="danger"
            onClick={() => {
              Neverauthorized(props.content.operation_id);
            }}
          >
            <FaCircleXmark style={{ marginTop: "5px", fontSize: "20px" }} />
            &nbsp;
            <h4 style={{ color: "white" }}>ไม่อนุมัติแผนการบิน</h4>
          </Button>
        </div>
      );
    } else if (props.content.status === 2) {
      return (
        <button
          className="custom-btn btnCancel"
          onClick={() => {
            Rescindedoperation(props.content.operation_id);
          }}
        >
          <div style={{ display: "flex" }}>
            <FaCircleXmark style={{ marginTop: "5px", fontSize: "20px" }} />
            &nbsp;
            <h4 style={{ color: "white", margin: "auto" }}>
              ยกเลิกการอนุมัติแผนการบิน
            </h4>
          </div>
        </button>
      );
    } else {
      return null;
    }
  }

  function matchingPurpose(purposeNumber) {
    switch (purposeNumber) {
      case "1":
        return "เพื่อการเล่นเป็นงานอดิเรก ความบันเทิง หรือ เพื่อการกีฬา";
      case "2":
        return "เพื่อการรายงานเหตุการณ์หรือรายงานจราจร (สื่อมวลชน)";
      case "3":
        return "เพื่อการวิจัย ทดลอง ทดสอบ ตามประกาศ กสทช.";
      case "4":
        return "เพื่อการวิจัยและพัฒนาอากาศยาน เพื่อการพาณิชย์";
      case "5":
        return "เพื่อการถ่ายภาพ ถ่ายทำหรือการแสดงในภาพยนต์หรือรายการโทรทัศน์";
      case "6":
        return "เพื่อสำรวจสิ่งปลูกสร้าง";
      default:
        return "อื่นๆ";
    }
  }

  return (
    <Modal
      show={props.toggleModal}
      onHide={props.onHide}
      aria-labelledby="contained-modal-title-vcenter"
      backdrop="static"
      size="xl"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>ข้อมูลการบิน</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row>
            <Col xs={7}>
              <MapContainer
                center={[
                  props.content.positions[0].Lat,
                  props.content.positions[0].Lon,
                ]}
                zoom={13}
                keyboard={true}
                style={{
                  width: "100%",
                  height: "500px",
                  borderRadius: "25px",
                  border: "5px solid black",
                }}
              >
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                <Polygon
                  pathOptions={{ color: "blue" }}
                  positions={positionsArrayToPolygon(props.content.positions)}
                />
              </MapContainer>
            </Col>
            <Col xs={5}>
              <Stack gap={3}>
                <div className="p-2" style={{ lineHeight: 0.5 }}>
                  <p>รหัสปฏิบัติการ</p>
                  <p>{props.content.id}</p>
                </div>
                <div className="p-2" style={{ lineHeight: 0.5 }}>
                  <p>ประเภทการปฏิบัติการ</p>
                  <p>{props.content.type}</p>
                </div>
                <div className="p-2" style={{ lineHeight: 0.5 }}>
                  <Row>
                    <Col>
                      <p>เวลาเริ่มต้น</p>
                      <p>{formatDate(props.content.start)}</p>
                    </Col>
                    <Col>
                      <p>เวลาสิ้นสุด</p>
                      <p>{formatDate(props.content.end)}</p>
                    </Col>
                  </Row>
                </div>
                {/* <div className="p-2" style={{ lineHeight: 0.5 }}>
                  <p>พิกัด</p>
                  <p>
                    {arrayToString(props.content.positions).substring(0, 54)}...
                  </p>
                </div> */}
                {props.content.pilot_name != undefined ? (
                  <div className="p-2" style={{ lineHeight: 0.5 }}>
                    <Row>
                      <Col>
                        <p>นักบิน</p>
                        <p>{props.content.pilot_name}</p>
                      </Col>
                      <Col>
                        <p>รุ่นอากาศยาน</p>
                        <p>{props.content.drone_model}</p>
                      </Col>
                    </Row>
                  </div>
                ) : null}
                <div className="p-2" style={{ lineHeight: 0.5 }}>
                  <Row>
                    <Col>
                      <p>วัตถุประสงค์</p>
                      <p style={{ lineHeight: 1.5 }}>
                        {matchingPurpose(props.content.purpose)} : {props.content.purpose_etc}
                      </p>
                    </Col>
                  </Row>
                </div>
                {props.content.type === "STANDARD-SPECIFIC" ? (
                  <div className="p-2" style={{ lineHeight: 0.5 }}>
                    <Row>
                      <Col>
                        <div
                          onClick={() => {
                            getfiletoshow();
                          }}
                          style={{cursor:"pointer"}}
                        >
                          {console.log(props.content.file.name)}

                          {/* <div
                            style={{
                              width: "400px",
                              height: "40px",
                              border: "solid 1px ",
                              justifyContent:"center"
                            }}
                          >
                            {props.content.file.name}
                          </div> */}
                          <img src={fileicon} alt="file" style={{width:"30px",paddingBottom:"1px"}}/>
                          <input value={props.content.file.name} disabled/>
                        </div>
                      </Col>
                    </Row>
                  </div>
                ) : (
                  ""
                )}
                <div className="p-2" style={{ lineHeight: 0.5 }}>
                  <Row>
                    <Col>
                      <ExportKMLButton positions={props.content.positions} />
                      {/* <Button
                        onClick={() => {
                          navigator.clipboard.writeText(
                            arrayToString(props.content.positions)
                          );
                        }}
                      >
                        <FaLocationDot style={{ marginBottom: "3px" }} />
                        &nbsp; คัดลอกพิกัด
                      </Button> */}
                    </Col>
                  </Row>
                </div>
              </Stack>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <VerifyStatus />
        {/* <button onClick={props.onHide}>Close</button> */}
      </Modal.Footer>
    </Modal>
  );
}

export default UserOperationContentModal;
